export const url_v1 = "https://gps.id/v1";
export const url_v2 = "https://gps.id/v3";
